<template>
     <v-hover>
          <v-card 
             lat tile
             v-bind="$attrs"
              v-on="$listeners"
              slot-scope="{ hover }"
                :class="`elevation-${hover ? 4 : elevation}`"
                transition="scale-transition"
              >
              
              <v-layout class="v-header">
                <v-flex xs2>
                  <v-btn :to="`questionaire/${item._id}`" icon>
                   <v-avatar
                      :size="avatarSize"
                      :color="`${item._supplier.logo ? 'white' : 'primary'}`"
                      class="ml-3"
                    >
                      <img v-if="item._supplier.logo" v-avatar:logo :src="item._supplier.logo" alt="avatar" @error="loadError(item)">
                      <span v-else class="white--text headline"><span v-if="item._supplier.name">{{item._supplier.name.substring(0,1)}}</span></span>
                    </v-avatar>
                    </v-btn>
                </v-flex>
                <v-flex xs10>
                  <v-card-title primary-title class="pt-0 d-block">
                    <div>
                      <h4 class="title font-weight-light">{{item._supplier.name}}</h4>
                      <v-progress-linear v-model="percentage" height="1" class="card-progress"></v-progress-linear>
                      <p class="category d-inline-flex font-weight-light">{{timeStamp(item)}}</p>
                      </div>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-card-text class="pt-0">
               
              
                 
               <v-expansion-panel class="elevation-0 flat" v-model="active">
                  <v-expansion-panel-content
                          class="ma-0 pa-0 transparent"
                    >
                    <template v-slot:header class="pa-0">
                            <v-layout>
                <v-flex xs2></v-flex>
                <v-flex xs4 class="pl-2">
                    <card-tag  v-if="item.rating" type="rating" :tags="[{type: 'rating', name: item.rating}]" class="tag-list"></card-tag>
                   <card-tag type="employee" :tags="item.tags" class="tag-list" :selected="selectedNames"></card-tag>
                   <card-tag type="user" :tags="item.tags" class="tag-list" :selected="selectedNames"></card-tag>
               </v-flex>
                <v-flex xs3 class="pl-2">
                  <card-tag type="vragen" :tags="[{type: 'vragen', name: answer + '/' + count}]" class="tag-list" icon=""></card-tag>
                </v-flex>
                <v-flex xs3 class="pl-2" v-if="item.questions && percentage">
                  <card-tag type="score" :value="percentage" class="tag-list" unit="%"></card-tag>
                </v-flex>
                 </v-layout>
                      </template>
                       <hr class="mx-3 v-divider theme--light mt-2 mb-2" v-if="item.description">
                <div class="caption grey--text font-weight-light overflow-hidden dense-text">{{item.description}}</div>
                          <ol><li :class="{'font-weight-bold': questionCustom(question)}" v-for="(question,index) in questions"
                          :key="index">{{question.title}}{{questionMark(question)}}<span v-if="question.score>0"> <v-icon color="green" class="handle">check</v-icon>({{question.score}})</span></li></ol>
                           <v-card-actions v-if="item.questions">
                              <v-spacer></v-spacer><v-btn flat @click="reset">reset</v-btn>
                          </v-card-actions>
                  </v-expansion-panel-content>
               </v-expansion-panel>
                 
              </v-card-text>
          </v-card>
          </v-hover> 
</template>
<script>
import {
  mapGetters,
  mapState,
  mapActions
} from 'vuex'

export default {
  inheritAttrs: false,

  props: {
    item: {
      type: Object,
      default: {}
    },
    elevation: {
      type: [Number, String],
      default: 1
    },
    avatarSize: {
      type: [Number, String],
      default: 48
    },
  },
  data: () => ({
      cols: 3,
      active: [],
      max: 10
    }),
  mounted ()  {
    
  },
  computed: {
    ...mapGetters('tag',['list','selectedTags','selectedNames']),
     ...mapState('auth', ["settings"]),
    _questions () {
          if (!this.settings.questions) return [{}]
          return this.settings.questions
    },
    questions () {
      return this.item.questions || this._questions
    },
    answer() {
      return this.questions.filter(q => q.score > 0).length
    },
    count() {
      return this.questions.length
    },
    score() {
        return this.questions.map(item => (item.score) * (item.weight || 1)).reduce((prev, next) => prev + next);
    },
    total() {
        return this.questions.map(item => (item.weight || 1) * this.max).reduce((prev, next) => prev + next); 
    },
        percentage() {
            return Math.round(this.score/this.total*100)
        }
  },
  methods: {
    ...mapActions('match', ['saveItem']),
     reset(){
       
         var self = this
          this.saveItem({item: {_id: this.item._id, questions: null}, next: function(item){
             self.item.questions = null
          }})
      },
     timeStamp (item){
        if (!item.event_date) return
        var m = this.$moment(item.event_date, this.$moment.ISO_8601)
        if (!m.isValid()) return this.$moment().format("dddd D MMMM YYYY [om] HH:mm")
        return   m.format("dddd D MMMM YYYY [om] HH:mm");
      },
    banner (url, def) {
      if (!url) url = def
      return this.$config.getIMageLink('banner',url,true)
    },
    loadError(item){
      item.logo = false
    },
    questionCustom (question) {
      return this._questions.filter(q => q.title == question.title).length == 0
    },
    questionMark(question) {
          if (question.title && question.title.indexOf('?') == -1) return '?'
      }
  }
}
</script>

<style lang="scss">
.v-card .v-avatar{
    min-width:48px;
} 
.v-card .v-header {
  padding-top: 30px;
}
.card-overlay{
   /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+1,7db9e8+100 */
    background: RGBA(0,0,0,0.7); /* Old browsers */
    background: -moz-linear-gradient(top,  RGBA(0,0,0,0.7) 1%, transparent 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top,  RGBA(0,0,0,0.7) 1%,transparent 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  RGBA(0,0,0,0.7) 1%,transparent 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='RGBA(0,0,0,0.7)', endColorstr='transparent',GradientType=0 ); /* IE6-9 */

  }
  .card-progress{
    margin:0px;
  }
  .v-card--material {
    &__header {
      &.v-card {
        border-radius: 4px;
      }
    }
  }
  .v-btn--flat {
      height: auto;
  }
  .v-rating .v-icon {
    padding: 0.1em;
}
.v-card__actions.floating {
    position:absolute;
}
.v-card .overflow-hidden{
  max-height:40px;
  text-overflow: ellipsis;
}
.v-card p {
  margin-bottom:0;
}
.opacity-0 {
  opacity: 0;
}
.dense-text{
  line-height: 1.2em!important;
     font-size: 0.7em!important;
}
.v-card.elevation-0 {
  background:transparent;
}


</style>